import * as XLSX from 'xlsx';

const getExportCols = (columns) =>
  columns.filter((col) => col.dataIndex && col.exportable !== false);

const getCellValue = (col, row) => {
  const val = row[col.dataIndex];
  if (col.exportRender) return col.exportRender(val, row);
  if (val === null || val === undefined) return '';
  return val;
};

const colTitle = (col) =>
  typeof col.title === 'string' ? col.title : String(col.dataIndex ?? '');

export const exportToExcel = (columns, dataSource, filename = 'export') => {
  const exportCols = getExportCols(columns);
  const headers = exportCols.map(colTitle);
  const rows = dataSource.map((row) => exportCols.map((col) => getCellValue(col, row)));

  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);

  worksheet['!cols'] = exportCols.map((col) => {
    const maxLen = Math.max(
      colTitle(col).length,
      ...dataSource.map((row) => String(getCellValue(col, row)).length)
    );
    return { wch: Math.min(Math.max(maxLen + 2, 10), 50) };
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Ma'lumotlar");
  XLSX.writeFile(workbook, `${filename}.xlsx`);
};

export const printTable = (title, columns, dataSource) => {
  const printCols = getExportCols(columns);
  const headers = printCols.map((col) => `<th>${colTitle(col)}</th>`).join('');
  const rows = dataSource
    .map((row) => {
      const cells = printCols.map((col) => `<td>${getCellValue(col, row)}</td>`).join('');
      return `<tr>${cells}</tr>`;
    })
    .join('');

  const date = new Date().toLocaleString('uz-UZ');

  const html = `<!DOCTYPE html>
<html lang="uz">
<head>
  <meta charset="UTF-8" />
  <title>${title || 'Print'}</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif; font-size: 12px; color: #1a1a2e; padding: 24px; }
    h2 { margin-bottom: 8px; font-size: 17px; color: #1a1a2e; }
    .meta { margin-bottom: 16px; color: #888; font-size: 11px; }
    table { width: 100%; border-collapse: collapse; }
    thead th { background: #eef2ff; color: #333; font-weight: 600; padding: 9px 12px; text-align: left; border: 1px solid #d0d8ff; white-space: nowrap; }
    tbody td { padding: 8px 12px; border: 1px solid #eee; vertical-align: top; }
    tbody tr:nth-child(even) { background: #f9faff; }
    tbody tr:hover { background: #f0f2ff; }
    @media print {
      body { padding: 0; }
      @page { margin: 1.2cm; }
    }
  </style>
</head>
<body>
  ${title ? `<h2>${title}</h2>` : ''}
  <p class="meta">Sana: ${date} &nbsp;&bull;&nbsp; Jami: ${dataSource.length} ta yozuv</p>
  <table>
    <thead><tr>${headers}</tr></thead>
    <tbody>${rows}</tbody>
  </table>
</body>
</html>`;

  const win = window.open('', '_blank', 'width=960,height=720');
  if (!win) return;
  win.document.write(html);
  win.document.close();
  setTimeout(() => { win.focus(); win.print(); }, 400);
};
